/**
 * 区分 numberingTarget（numbering_rules.numbering_target）
 * 出典：要件書 5.2（日本語は実装メモで決定）
 */
export const NUMBERING_TARGET_VALUES = [
  'customer',
  'case',
  'transaction',
  'contract',
  'personnel',
  'goal',
  'form',
  'reportTemplate',
] as const;

export type NumberingTarget = (typeof NUMBERING_TARGET_VALUES)[number];

export const NUMBERING_TARGET_LABELS: Readonly<Record<NumberingTarget, string>> = {
  customer: '顧客',
  case: '案件',
  transaction: '取引',
  contract: '契約',
  personnel: '要員',
  goal: '目標',
  form: 'フォーム',
  reportTemplate: 'レポート雛形',
};
